/* eslint-disable  */
import React from 'react';
import { useState } from 'react';
import { Button, Grid, TextField } from '@material-ui/core';
import { Autocomplete } from '@mui/material';
import { useDepartments } from '~/departments';
//import { useEmployees } from '~/employees';


const AssignEmployeeForm = props => {


    const {
        employees,
        setModalOpen,
        onSubmit,
        department_id,
        title_id
    } = props;

    const [enabled, setEnabled] = useState(false)
    const [assignEmployee, setAssignEmployee] = useState()

    const handleSubmit = async (event) => {
        // console.log('submitted')
        event.preventDefault();
        setModalOpen(false)
        
        onSubmit && onSubmit({
            ...assignEmployee
        })
    }
    const handleChangeAssignEmployee = (value) => {
        // console.log(value, "????", department_id)

        setAssignEmployee({
            ...value
        })
        setEnabled(true)
    }



    return (

        <form onSubmit={handleSubmit} >

            <Grid container spacing={3} justifyContent='flex-end'>

                <Autocomplete
                    name='Employees Names'
                    //loading={isLoading}
                    fullWidth
                    options={employees || []}
                    getOptionLabel={opt => opt.name}
                    renderInput={(params) => {
                        return (
                            <TextField {...params} label='employees' />)
                    }}
                    onChange={(e, value) => handleChangeAssignEmployee(value)}

                >
                </Autocomplete>

                <Grid item >
                    <Button color='secondary'
                        onClick={() => setModalOpen(false)}>
                        Cancel
                    </Button>
                </Grid>

                <Grid item>
                    <Button type='submit'
                        variant='contained'
                        color='primary'
                        disabled={!enabled}
                        onClick={handleSubmit}>
                        Submit
                    </Button>
                </Grid>
            </Grid>
        </form>


    )
};
export default AssignEmployeeForm;